import React from "react";
import { useTranslation } from "react-i18next";

const CheckInTruckF15 = ({
  nextForm,
  backForm,
  truckForm,
  setTruckForm,
  inOrOut,
  edit = false
}) => {
  const { t } = useTranslation();

  const handleTruckChange = (key, field, value) => {
    if (key === "anomalies") {
      setTruckForm((prevForm) => ({
        ...prevForm,
        anomalies: value,
      }));
    } else {
      setTruckForm((prevForm) => ({
        ...prevForm,
        truck_inspection: {
          ...prevForm.truck_inspection,
          [key]: {
            ...prevForm.truck_inspection[key],
            [field]: value,
          },
        },
      }));
    }
  };

  const storeData = () => {
    localStorage.setItem("truckForm", JSON.stringify(truckForm));
  };

  return (
    <div className={`white-cont ${edit ? 'questions-cont' : ""}`}>
      <h2 className="global-h2 light-black" id="form-header">
        {inOrOut
          ? t("forms.type.vehicle.check-in.header")
          : t("forms.type.vehicle.check-out.header")}
      </h2>
      <h4 className="global-h4 gray bottom-space">
        {t("forms.type.f15.truck-subheader")}
      </h4>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          nextForm();
          storeData();
        }}
      >
        {Object.keys(truckForm.truck_inspection).map(
          (key, index) =>
            key !== "truck_anomalies" &&
            key !== "employee_pin" && (
              <>
                <div key={`${key}-${index}`} className="form-group">
                  <label className="input-label required">
                    {t(`forms.type.f15.truck.labels.${key}`)}
                  </label>
                  <div className="input-cont">
                    <fieldset className="fieldsets">
                      <div className="radio-options">
                        <input
                          type="radio"
                          name={key}
                          data-testid={`good-${key}-${index}`}
                          checked={truckForm.truck_inspection[key].value}
                          onChange={() => handleTruckChange(key, "value", true)}
                          className="radio-input"
                          required
                        />{" "}
                        <label>
                          {t(
                            "forms.type.vehicle.placeholders.select-condition.good"
                          )}
                        </label>
                      </div>
                      <div className="radio-options">
                        <input
                          type="radio"
                          name={key}
                          data-testid={`poor-${key}-${index}`}
                          checked={
                            truckForm.truck_inspection[key].value === false
                          }
                          onChange={() => handleTruckChange(key, "value", false)}
                          className="radio-input"
                        />
                        <label>
                          {t(
                            "forms.type.vehicle.placeholders.select-condition.poor"
                          )}
                        </label>
                      </div>
                      <div className="radio-options">
                        <input
                          type="radio"
                          name={key}
                          data-testid={`na-${key}-${index}`}
                          checked={
                            truckForm.truck_inspection[key].value === null
                          }
                          onChange={() => handleTruckChange(key, "value", null)}
                          className="radio-input"
                        />
                        <label>N/A</label>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="form-group">
                  <label></label>
                  <div className="input-cont">
                    <input
                      className="text-input"
                      style={{ width: "100%" }}
                      type="text"
                      placeholder={t("forms.type.vehicle.input-headers.notes")}
                      value={truckForm.truck_inspection[key].notes}
                      onChange={(e) =>
                        handleTruckChange(key, "notes", e.target.value)
                      }
                      required={truckForm.truck_inspection[key].value === false}
                    />
                  </div>
                </div>
              </>
            )
        )}
        <div className="form-group">
          <label className="input-label">
            {t("forms.type.f15.truck.labels.anomalies")}
          </label>
          <div className="input-cont">
            <input
              className="text-input"
              placeholder={t("forms.type.f15.truck.labels.anomalies")}
              onChange={(e) =>
                handleTruckChange("anomalies", "anomalies", e.target.value)
              }
              value={truckForm.anomalies}
              type="text"
            />
          </div>
        </div>
        <div className="full-cont">
          <button className="change-pwd-btn" type="submit" data-testid="continue-btn">
            {t("buttons.continue")}
          </button>
          <button className="cancel-btn" type="button" onClick={backForm}>
            {t("buttons.back")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default React.memo(CheckInTruckF15);
